import React from "react"
import { Box, Divider } from "@mui/material"


export default function AppBasicTableLegend({ items=[] }) {
    return <Box sx={{  display: 'flex', gap: 1  }}>
		{ items.map((item, idx) => <Box key={idx} component="span" sx={{  display: 'flex', gap: .5, alignItems: 'center'  }}>
			{ item.type !== 'line' 
				? <Box sx={{  backgroundColor: item.color, borderRadius: '50%', width: 12, height: 12  }} /> 
				: <Divider sx={{  borderColor: item.color, width: 12  }} />
			}
			<Box> {item.label} </Box>
		</Box>) }
    </Box>
}